<div class="modal-header ">
    <div class="div-width-l">
        <h4 class="modal-title">{{name}}</h4>
    </div>
    <div class="div-width-r">
        <button type="button" class="close" aria-label="Close" (click)="close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
</div>
<div class="modal-body modal-height">
    <img class="text-center pic-size" src="{{noti.notiFile.url}}">
</div>
<!-- <div class="modal-footer justify-content-start" *ngIf="isLoginged">
    <div class="form-check">
        <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" [(ngModel)]="notShow" >
        <label class="form-check-label text-black" for="flexCheckDefault">
          ไม่ต้องแสดงอีกในวันนี้ 
        </label>
      </div>
</div> -->